/**
 * MessageBubble utils — CUADRO NEGRO Extracción Mínima Segura.
 *
 * Funciones puras (o casi-puras) extraídas de MessageBubble.jsx.
 *
 * - formatMessageTimestamp(timestamp, language): "18 mar 26  8:03"
 * - formatFullTimestamp(timestamp, language): timestamp con segundos.
 * - isTutorialContent(content): heurística MEPP para detectar
 *   tutoriales/guías paso a paso.
 *
 * Reglas respetadas:
 * - NO se modifica el output ni el formato.
 * - NO se altera la lógica original.
 * - `language` se pasa por parámetro (en el original era closure).
 */

const MONTH_NAMES_ES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const MONTH_NAMES_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Formatear timestamp del mensaje usando hora LOCAL del dispositivo.
 * Formato: "18 mar 26   8:03"
 */
export function formatMessageTimestamp(timestamp, language) {
  if (!timestamp) return null;
  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return null;

    const day = date.getDate();
    const monthNames = language === 'es' ? MONTH_NAMES_ES : MONTH_NAMES_EN;
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day} ${month} ${year}   ${hours}:${minutes}`;
  } catch (e) {
    return null;
  }
}

/**
 * Fecha/hora completa con segundos (para tooltip/hover).
 */
export function formatFullTimestamp(timestamp, language) {
  if (!timestamp) return null;
  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return null;

    const locale = language === 'es' ? 'es-ES' : 'en-US';

    return date.toLocaleString(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: language === 'en',
    });
  } catch (e) {
    return null;
  }
}

/**
 * Detect if message looks like a MEPP tutorial/guide content.
 */
export function isTutorialContent(content) {
  if (!content) return false;
  const stepPatterns = [
    /paso\s*\d+[.:]/i,
    /step\s*\d+[.:]/i,
    /\*\*paso\s*\d+/i,
    /\*\*step\s*\d+/i,
    /^\d+\.\s+\*\*/m,
    /objetivo:|requisitos:|prerrequisitos:|pasos del tutorial|verificación/i,
    /tutorial|procedimiento|guía paso a paso|instrucciones:/i,
  ];
  return stepPatterns.some((pattern) => pattern.test(content));
}
